import Mask from '../../src/legacy/Mask.tsx';
export default Mask;
